<template>
    <div class="row">
        <div class="col-sm-12">
            <button class="btn large" :disabled="disabled" @click="onClick">Suchen</button>
        </div>
    </div>  
</template>


<script>
export default {

    data() {
        return {
            catseo: null,
            carseo: null,
            type: null,
            
        }
    },

    computed: {
        disabled() {
            return !this.catseo || !this.carseo
        }
    },

    methods: {

        onClick() {
            window.location = App.url+'/category/' + this.carseo + '/' + this.catseo;
        }

    },

    created() {

        App.event.listen('car.category.selected', (catseo) => { this.catseo = catseo })
        App.event.listen('car.type.selected', ({carseo}) => { this.carseo = carseo })

        App.event.listen('car.brand.selected', () => {
            this.type = null;
            this.category = null;
        })

        App.event.listen('car.year.selected', () => {
            this.type = null;
            this.category = null;
        })

}
}
</script>
